var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCategory6 = function SvgCategory6(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    className: "category6_svg__w-full category6_svg__h-full",
    viewBox: "0 0 80 58"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#727277",
    strokeMiterlimit: 10,
    strokeWidth: 1.6,
    clipPath: "url(#category6_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M.964 49.617V57h78.072v-7.382zM74.448 49.575c-.01-9.044-3.315-17.747-9.253-24.357-5.928-6.61-14.053-10.657-22.737-11.308V6.108h7.383V1H30.159v5.118h7.383v7.802c-8.675.651-16.8 4.687-22.737 11.308-5.928 6.61-9.234 15.313-9.253 24.357h68.887z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "category6_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h80v58H0z"
  })))));
};
export default SvgCategory6;